<template>
  <v-app class="guest-wrapper">
    <v-container fill-height>
      <v-layout row wrap align-center justify-center fill-height>
        <v-toolbar color="elevation-0 transparent" dark absolute width="100%">
          <v-spacer></v-spacer>
          <app-lang></app-lang>
        </v-toolbar>
          
        <v-flex xs12>
          <slot></slot>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import AppLang from "./AppLang";

export default {
  data() {
    return {};
  },
  components: {
    AppLang
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scope>
  .guest-wrapper {
    background-image: url('/images/login.png') !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-position: center center !important;
  }
</style>
